import './Footer.scss';

import { b2x } from '@b2x/react/src';

import { Accordion } from './Accordion';
import { useAppContext, useAppStaticContext } from './AppContext';
import { Container } from './Container';
import { FooterContentType } from './contentTypes';
import { t } from './i18n/i18n';
import { ListAFromMenu } from './ListAFromMenu';
import { SocialIcons } from './SocialIcons';

export interface FooterProps {}

export const Footer = (props: FooterProps) => {
  const footerMenu = b2x.useMenu('MENU_FOOTER');
  const footerBottomMenu = b2x.useMenu('MENU_BOTTOM_FOOTER');
  const footerContent = b2x.useContent<FooterContentType>('FOOTER_CONTENT');
  const { footerCheckout } = useAppContext();
  const { setFooterCopyrightRef } = useAppStaticContext();

  return (
    <footer className="footer" id="footer">
      {!footerCheckout && (
        <>
          <Container className="position-relative footer-bg-container">
            <b2x.Div
              className="background d-none d-lg-block"
              style={{
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
                zIndex: '-1',
              }}
            >
              {footerContent?.body.imageDesktop && (
                <b2x.AssetAsBackgroundV2 backgroundSize="cover" {...footerContent.body.imageDesktop} />
              )}
            </b2x.Div>
            <div className="pt-lg-3 pb-xl-6 pt-xl-5">
              <b2x.Row>
                <b2x.Col className="d-lg-none py-3" display={'flex'} justifyContent={'center'} size={12}>
                  <SocialIcons />
                </b2x.Col>

                <b2x.Col size={{ lg: 6, xl: 5 }}>
                  <div className="pb-4">
                    <AccordionFooterMenu id="first-footer-accordion" menu={footerMenu} />
                  </div>
                </b2x.Col>
                <b2x.Col className="d-none d-lg-block" size={{ lg: 2 }}>
                  <p className="h6 fw-bold me-3 mb-3 text-uppercase"> {t('misc.followUs')} </p>
                  <SocialIcons />
                </b2x.Col>
              </b2x.Row>
            </div>
          </Container>
          <b2x.Div className="d-block d-lg-none" textAlign={'center'}>
            <b2x.ImageFromContentV2 {...footerContent?.body.imageMobile} alt={footerContent?.body.imageMobile?.alt} />
          </b2x.Div>
        </>
      )}

      <div className="bg-primary text-white py-2" ref={setFooterCopyrightRef}>
        <Container>
          <b2x.Row>
            <b2x.Col size={{ lg: 5, xs: 12 }}>
              <b2x.Div
                alignItems={'center'}
                className="h-100 pb-1 pb-lg-0"
                display={'flex'}
                justifyContent={{ lg: 'start', xs: 'center' }}
              >
                {footerContent && <div className="small">{b2x.formatHtml(footerContent.body.copyright)}</div>}
              </b2x.Div>
            </b2x.Col>
            <b2x.Col size={{ lg: 7, xs: 12 }}>
              <b2x.Div
                alignItems={'center'}
                className="h-100 small"
                display={'flex'}
                justifyContent={{ lg: 'end', xs: 'center' }}
              >
                <b2x.Div className="d-none d-lg-block">
                  {footerBottomMenu && <ListAFromMenu menu={footerBottomMenu} textUppercase />}
                </b2x.Div>
              </b2x.Div>
            </b2x.Col>
          </b2x.Row>
        </Container>
      </div>
      <div className="text-right">
        <Container>
          <b2x.Row>
            <b2x.Col>
              <div className="py-2">
                <b2x.PaymentIcons className="footer-payments justify-content-center justify-content-lg-end" />
              </div>
            </b2x.Col>
          </b2x.Row>
        </Container>
      </div>
    </footer>
  );
};

interface AccordionFooterMenuProps {
  id: string;
  menu?: b2x.MenuApiDto;
}
const AccordionFooterMenu = ({ id, menu }: AccordionFooterMenuProps) => {
  const { session } = b2x.useAppContext();
  const { showAccountOffcanvas } = useAppStaticContext();
  return (
    <Accordion
      columnLayoutFrom="lg"
      id={id}
      itemBodyClassName="pt-0 pb-3"
      itemButtonClassName="itemButtonClassName fw-bold mb-lg-1 p-3 p-lg-0"
      itemClassName="itemClassName"
    >
      {menu?.children.map(
        (column) =>
          column.label && (
            <b2x.AccordionItem
              className={column.cssClass}
              headingClass="h5"
              headingTag="h3"
              id={`accordionItem-${column.id}`}
              key={column.code}
              title={column.label}
            >
              {column.subTitle && <div>{column.subTitle}</div>}
              {column.children.map((li) =>
                li.code === 'SITE_CCN_AREA' ? (
                  session?.userLogged ? (
                    li.children.map(
                      (subLi) =>
                        subLi.link && (
                          <div key={subLi.code}>
                            <b2x.router.NavLink
                              className="text-reset text-decoration-none d-block pb-1"
                              to={subLi.link}
                            >
                              {subLi.label}
                            </b2x.router.NavLink>
                          </div>
                        )
                    )
                  ) : (
                    <div key={li.code}>
                      <b2x.BlankButton className="d-block " onClick={showAccountOffcanvas}>
                        {t('account.login')}
                      </b2x.BlankButton>
                    </div>
                  )
                ) : (
                  li.link && (
                    <div key={li.code}>
                      <b2x.router.NavLink className="text-reset text-decoration-none d-block pb-1" to={li.link}>
                        {li.label}
                      </b2x.router.NavLink>
                    </div>
                  )
                )
              )}
            </b2x.AccordionItem>
          )
      )}
    </Accordion>
  );
};
